import React, { FC } from 'react';
import moment from 'moment';

import { fc } from 'i18n';
import { arrowRightFilled, crossFilled } from 'assets/icons';
import { IRunway, IRunwayStatus } from 'types/redux/runways';
import { SvgWrapper } from 'components/atoms/svg-wrapper';

import styles from './styles.module.css';

interface IRunwayStatusTileProps {
  runway: IRunway | null;
  statusInfo: IRunwayStatus;
}

export const RunwayStatusTile: FC<IRunwayStatusTileProps> = ({ runway, statusInfo }) => {
  const direction = runway?.directions?.[statusInfo.directionIndex];
  const isClosed = statusInfo.mode === 'CLOSED';

  const columns = [
    { value: statusInfo.runwayId, label: 'RWY' },
    // { value: statusInfo.centrelineIntensity, label: 'CAT' },
    { value: direction || '-', label: 'DIR' },
    { value: statusInfo.mode, label: 'MODE' },
  ];

  return (
    <div className={styles.tile}>
      <div className={styles.header}>
        <span className={`${styles.headerText} ${styles.bold}`}>{`${fc('updated at')}:  `}</span>
        <span className={styles.headerText}>{moment(statusInfo.statusAt).format('DD/MM/YYYY, HH:mm:ss')}</span>
      </div>
      <div className={styles.content}>
        <div className={styles.row}>
          {columns.map((column, index) => (
            <div key={index} className={styles.column}>
              <div className={styles.columnTitle}>{column.label}</div>
              <div className={styles.columnText}>{column.value}</div>
            </div>
          ))}
          <div className={`${styles.column} ${styles.icon}`}>
            <SvgWrapper
              className={!isClosed && !!statusInfo.directionIndex ? styles.rotatedIcon : ''}
              width={15.6}
              height={15.6}
              details={isClosed ? crossFilled : arrowRightFilled}
            />
          </div>
        </div>
      </div>
    </div>
  );
};
